module.exports = __webpack_public_path__ + "static/Thumb_MM_Mid_Sausalito_MM-6dd7fd7f2b77bb7567e2432ccedda37e.png";